import { render, staticRenderFns } from "./StepSuccess.vue?vue&type=template&id=0fb411ca&scoped=true&"
import script from "./StepSuccess.vue?vue&type=script&lang=js&"
export * from "./StepSuccess.vue?vue&type=script&lang=js&"
import style0 from "./StepSuccess.vue?vue&type=style&index=0&id=0fb411ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb411ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
